var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React from "react";
import PropTypes from "prop-types";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
import { isPaddingTokenProp } from "@twilio-paste/style-props";
var Card = React.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CARD",
      padding = "space100",
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop
    } = _b,
    props = __objRest(_b, ["children", "element", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop"]);
  return React.createElement(Box, __spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
    ref,
    as: "article",
    borderWidth: "borderWidth10",
    borderColor: "colorBorderWeaker",
    borderStyle: "solid",
    borderRadius: "borderRadius30",
    element,
    padding,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop,
    backgroundColor: "colorBackgroundBody"
  }), children);
});
Card.propTypes = {
  element: PropTypes.string,
  padding: isPaddingTokenProp,
  paddingTop: isPaddingTokenProp,
  paddingRight: isPaddingTokenProp,
  paddingBottom: isPaddingTokenProp,
  paddingLeft: isPaddingTokenProp
};
Card.displayName = "Card";
export { Card };